import _ from 'lodash';
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import { IThemeCategory } from '@typings';
import PopupSpinner from '@components/PopupSpinner.vue';
import '@styles/popup/category.scss';

@Component({
  components: {
    PopupSpinner,
  },
})
export default class PopupCategory extends Vue {
  @Prop() readonly checkedCategories!: number[];

  @Ref('categoryPopup') categoryPopup!: HTMLDivElement;

  loaded: boolean = false;
  isCheckAll: boolean = false;
  categoryList: IThemeCategory[] = [];

  get allSelcetedText(): TranslateResult {
    return this.isCheckAll
      ? this.$t('mov_making.select_all_reset')
      : this.$t('mov_making.select_all');
  }

  async created() {
    const fetchedCategories = await this.$store.dispatch('CATEGORY_SELECT');
    const categories = fetchedCategories.data.items;
    this.categoryList = this.getDefaultCategoryList(categories);
    this.loaded = true;
  }

  render() {
    return this.loaded
    ? (
      <div ref="categoryPopup" class="popup category" onClick={this.popupEvent}>
        <div class="popup-container">
          <div class="popup-header">
            <h2>
              {this.$t('mov_making.condition_search')}
              <span>{this.$t('mov_making.msg_multiple_select')}</span>
            </h2>
            <button class="button normal" onClick={this.checkAll}>
              <span>{this.allSelcetedText}</span>
            </button>
          </div>
          <div class="popup-body">
            <div class="category-list">
              <ul>
                {_.map(this.categoryList,({ id, name, isChecked }) => {
                  return (
                    <li key={id}>
                      <div class="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => this.checkCategory(id)}
                          />
                          <span>{name}</span>
                        </label>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
          <div class="popup-footer">
            <div class="button-box">
              <button class="button normal" onClick={this.closePopup}>
                {this.$t('common.b_cancel')}
              </button>
              <button class="button primary" onClick={this.categoryApply}>
                {this.$t('confirm')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
    : <popup-spinner opened={!this.loaded} />;
  }

  checkAll(): void {
    this.isCheckAll = !this.isCheckAll;
    this.categoryList = _.map(this.categoryList, (category) => {
      return {
        ...category,
        isChecked: this.isCheckAll,
      };
    });
  }

  checkCategory(id: number): void {
    this.categoryList = _.map(this.categoryList, (category) => {
      const { isChecked } = category;
      return {
        ...category,
        isChecked: category.id !== id ?  isChecked : !isChecked,
      };
    });
  }

  getDefaultCategoryList(
    categories: IThemeCategory[],
  ): IThemeCategory[] {
    return _.map(categories, (category) => {
      const isChecked =
        _.findIndex(this.checkedCategories, (id) => id === category.id) > -1;
      return {
        ...category,
        isChecked,
      };
    });
  }

  getCheckedCategories(): number[] {
    const checkedCategoryList = _.filter(
      this.categoryList,
      (category) => category.isChecked,
    );
    return _.map(checkedCategoryList, ({ id }) => id);
  }

  closePopup(): void {
    this.$emit('hideCategoryPopup');
  }

  popupEvent(event: Event): void {
    const isTargetPopup = event.target === this.categoryPopup;
    isTargetPopup && this.closePopup();
  }

  categoryApply(): void {
    const checkedCategories = this.getCheckedCategories();
    this.$emit('confirmCategory', checkedCategories);
    this.closePopup();
  }
}
